export default __webpack_public_path__ + "static/3-cc9db91d7a79e96c75119b568ae9c3c9.webp";